// extracted by mini-css-extract-plugin
export var mainContainer = "ux-ui-design-module--main-container--cZRt8";